import React, {Component} from 'react';
import CountUp from 'react-countup';
import { ticketSolved } from '../store/actions/chatActions';

/* global $ */

class Loader extends Component {
    state = {
        show: false,
        timer: 5,
        showActions: false,
    }

    timer = null;

    updateTimer = () => {
        if(this.state.timer <= 0){
            
            window.clearInterval(this.timer);
            this.setState({showActions: true});
        }else{
            this.setState({timer: this.state.timer - 1});
        }
    }

    componentDidUpdate(props, state){
        if(props.appLoading && !this.props.appLoading && this.state.show === true){
            //Do a graceful exit
            
            $('#big-loader').removeClass('fadeIn').addClass('fadeOut');
            let self = this;
            setTimeout(() => {
                this.setState({show: false});
            }, 2000);
            
        }else if(!props.appLoading && this.props.appLoading){
            this.setState({show: true, timer: 5, showActions: false}, () => {
                this.timer = setInterval(this.updateTimer, 1000);
            });
        }
    }

    componentDidMount(){
        if(this.props.appLoading && !this.state.show){
            this.setState({show: true, timer: 5, showActions: false}, () => {
                this.timer = setInterval(this.updateTimer, 1000);
            });
        }
    }

    render(){
        return (
            <div className="big-loader animated fadeIn" id="big-loader" style={{display: this.state.show ? 'block' : 'none'}}>
                {this.props.appLoading ?
                <div className="app-loader-progress">
                
                    <CountUp
                        className="counter"
                        start={0}
                        end={97}
                        duration={2}
                    />%</div>
                : null}
                <div className="lds-dual-ring"></div>   
                {this.state.showActions ?
                    <div className="loading-actions animated fadeIn">
                        <p className="text-center">
                            It seems to be taking longer than expected to get you signed in.<br />
                            You can use the buttons below you try reloading this page.  If you are still experiencing problems, try signing out, and then signing back in.


                        </p>
                        <p className="text-center">
                            <button className="btn btn-success" onClick={e => {
                                e.preventDefault();
                                window.location.reload();
                            }}><i className="zmdi zmdi-refresh" /> &nbsp; Reload</button> &nbsp; <button className="btn btn-danger" onClick={e => {
                                e.preventDefault();
                                window.localStorage.clear();
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }}><i className="zmdi zmdi-power" /> &nbsp; Sign Out</button>
                        </p>
                    </div>
                : null}
 
            </div>
        )
    }
}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.js